import { Color } from '../../../../../../utils/theme/types/color'

export const useStyles = (color: Color) => ({
  container: {
    paddingTop: '40px',
    paddingRight: '40px',
    paddingLeft: '1px',
    paddingBottom: '15px',
    width: '100%',
    overflowY: 'auto',
    height:'100%'
  },
  containerBody: {
    marginTop: '20px',
  },
  gridLeft: (first:boolean) => ({
    paddingRight: first ? 5 : 0,
  }),
  gridRight: {
  },
  containerForm: {
    marginTop: '36px',
    marginBottom: '36px'
  },
  buttonsContainer: {
    marginTop: 3,
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .back': {
      width: '80px',
      height: '36px',
      textTransform: 'uppercase',
    },
    '& .next': {
      borderRadius: '4px',
      textTransform: 'uppercase',
    },
  },
})
